import { useTranslation } from 'react-i18next';

export function SentryFallback({ error }: { error: Error }) {
  const { t } = useTranslation();
  const message = t('errors.generic');
  const details = error.message || t('errors.generic');
  const stack = import.meta.env.DEV ? error.stack : undefined;

  return (
    <main className="container mx-auto p-4 pt-16">
      <h1>{message}</h1>
      <p>{details}</p>
      {stack && (
        <pre className="w-full overflow-x-auto p-4">
          <code>{stack}</code>
        </pre>
      )}
    </main>
  );
}
